module.exports = __webpack_public_path__ + "static/og-b8afc00c4cc0975afc487aff8259c776.png";